var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactsicon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.889 12.667a.889.889 0 01-.889-.89v-.888A4.446 4.446 0 014.794 6.76a2.667 2.667 0 113.7-3.8 2.667 2.667 0 012.268 4.69 4.446 4.446 0 012.794 4.127v.889c0 .49-.398.889-.89.889h-7.11a.889.889 0 01-.89-.89H2.89zm3.555-9.778a1.778 1.778 0 00-.888 3.318v1.238a3.557 3.557 0 00-2.667 3.444v.889h1.778A4.446 4.446 0 017.46 7.65a2.664 2.664 0 01.167-4.31 1.771 1.771 0 00-1.183-.451zm-.888 8.889v.889h7.11v-.89A3.557 3.557 0 0010 8.335V7.096a1.777 1.777 0 10-1.778 0v1.238a3.557 3.557 0 00-2.666 3.444z"
  })));
});
export default SvgContactsicon;